"use client";

import { TriangleAlert } from "lucide-react";
import { useTranslations } from "next-intl";
import { ErrorHomeButton, ErrorPageView } from "@/components/error-page/error-page-view";
import { Button } from "@/components/ui/button";

export default function ErrorPage({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations("errorPages");
  const note = error.digest && <p className="text-xs opacity-75">{t("reference")}: <code>{error.digest}</code></p>;
  return (
    <ErrorPageView icon={TriangleAlert} code="500" title={t("errorTitle")} text={t("errorText")} note={note}>
      <Button variant="secondary" onClick={reset}>{t("tryAgain")}</Button>
      <ErrorHomeButton label={t("home")} />
    </ErrorPageView>
  );
}
